import React from "react";
import MerchantDashboard from "./MerchantDashboard";

const ShopifyDashboard: React.FC = () => {
  return <MerchantDashboard platform="shopify" />;
};

export default ShopifyDashboard;
